<template>
  <ModalDefault header="y"
                modal_id="searchReportChatbotModal"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_1262')"
                footer="y"
                :method="searchChatBot"
                icon="bx bx-search mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class="row pb-2 pt-1 px-3">
        <!--Data inicial-->
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_537') }} </label>
          <div class="input-group mb-2">
            <input type="date"
                   v-model="reports.filter_report_chatbot.initial_date"
                   class="form-control input_forms">
          </div>
        </div>
        <!--Data final-->
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_809') }} </label>
          <div class="input-group mb-2">
            <input type="date"
                   v-model="reports.filter_report_chatbot.final_date"
                   class="form-control input_forms">
          </div>
        </div>
        <!--Canal-->
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_6') }} </label>
          <div class="input-group mb-2">
            <select v-model="reports.filter_report_chatbot.channel_id"
                    @change="searchChatbot()"
                    class="input_forms custom-select pl-50" style="min-width: 200px;">
              <option :value="null" disabled>{{ getTranslations('expression_7') }}</option>
              <option v-for="channel in channels.data"
                      :key="channel.id"
                      :value="channel.id">
                {{ channel.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-0 d-flex">
      <div>
          <div @click.prevent="clearSearch" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3 mr-2">
            <span class="">{{ getTranslations('expression_810') }}</span>
          </div>
      </div>
      <div>
          <button type="submit" @click.prevent="searchChatBot" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_811') }}</span>
          </button>
      </div>
    </div>
  </ModalDefault>
</template>

<script>

import ModalDefault from "../../components/general/ModalDefault";
import {mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalSearchReportChatbot",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['me', 'configs', 'channels']),
  },
  methods: {
    clearSearch() {
      this.reports.filter_report_chatbot = {
            bot_selected_id: null,
            initial_date: null,
            final_date: null,
            channel_id: this.reports.filter_report_chatbot.channel_id,
      }
      this.searchLeads()
    },
    async searchChatBot() {
      if(this.reports.report_main_menu_chatbot_clicks.length > 0 && this.reports.report_submenu_chatbot_clicks.length > 0) {
        await this.$store.dispatch('getReportMainChatBot', this.reports.filter_report_chatbot)
        await this.$store.dispatch('setReportSubmenuChatBot', this.reports.filter_report_chatbot)
        this.reports.search_report_chatbot = true
      } else if(this.reports.report_main_menu_chatbot_clicks.length > 0 && this.reports.report_submenu_chatbot_clicks.length === 0) {
        await this.$store.dispatch('getReportMainChatBot', this.reports.filter_report_chatbot)
        this.reports.search_report_chatbot = true
      }
      $(`#searchReportChatbotModal`).modal('hide')
    }
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>

<style scoped>

</style>
